// @ts-nocheck
import { Component, Input } from '@angular/core';
import { InputTextComponent } from '../input-text/input-text.component';

@Component({
    selector: 'lbca-list-reference',
    templateUrl: './list-reference.component.html',
    imports: [InputTextComponent ]
})
export class ListReferenceComponent {
	public option: any[] = [];
	public fieldProps;
	public labelValue;
	public entityValue;

	@Input() set label(value: string) {
		this.labelValue = value;
	}
	@Input() set field(value: any) {
		this.fieldProps = value;
	}

	@Input('options')
	set optionsList(val: any) {
		if (!val) return;
		this.option = [...val];
	}

	@Input() set value(valueSelected: string) {
		if (valueSelected || typeof valueSelected === 'boolean') {
			const { entityParameter } = this.fieldProps.auxEntity;
			const select = this.option.find((opt) =>
				entityParameter ? opt[entityParameter] === valueSelected : opt.id === valueSelected,
			);
			if (select) this.entityValue = select.label;
			else this.entityValue = '-';
		} else this.entityValue = '-';
	}

	constructor() {}
}
